module.exports = __webpack_public_path__ + "img/logo.3a9cbed5.png";